import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<GetOrdersApiParameter & UpdateSearchFieldsType, DispatchProp<customerActions>>;

export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Pages/WorkOrderHistory/UpdateSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateSearchFields];

const updateSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateSearchFields");
export default updateSearchFields;
